export const AR_FORM_EMAIL_PLACEHOLDERS = [
  { token: "clientName", label: "Client name" },
  { token: "clientEmail", label: "Client email" },
  { token: "contactPerson", label: "Contact person" },
  { token: "orderCode", label: "Order code" },
  { token: "transactionCode", label: "Transaction code" },
  { token: "ifastAccountNo", label: "iFAST account number" },
  { token: "consultantName", label: "Consultant name" },
  { token: "fundName", label: "Fund name" },
  { token: "investmentAmount", label: "Investment amount" },
  { token: "companyName", label: "Company name" },
  { token: "companyAddress", label: "Company address" },
  { token: "companyPhone", label: "Company phone" },
  { token: "companyEmail", label: "Company email" },
  { token: "companyWebsite", label: "Company website" },
  { token: "today", label: "Today" },
];

export const AR_FORM_PASSWORD_PLACEHOLDERS = [
  ...AR_FORM_EMAIL_PLACEHOLDERS,
  { token: "pdfPassword", label: "PDF password" },
];

export const DEFAULT_AR_FORM_EMAIL_SUBJECT =
  "Advisor Recommendation Form for {{clientName}}";

export const DEFAULT_AR_FORM_EMAIL_BODY =
  "<p>Dear {{contactPerson}},</p><p>Please find attached the Advisor Recommendation Form for {{clientName}} ({{transactionCode}}).</p><p>Kind regards,<br/>{{consultantName}}<br/>{{companyName}}</p>";

export const DEFAULT_AR_FORM_PASSWORD_SUBJECT =
  "Password for your AR Form {{transactionCode}}";

export const DEFAULT_AR_FORM_PASSWORD_BODY =
  "<p>The password to open the attached AR Form is: {{pdfPassword}}</p><p>Please keep this password confidential.</p>";

export const GI_DOCUMENT_EMAIL_PLACEHOLDERS = [
  { token: "clientName", label: "Client name" },
  { token: "clientEmail", label: "Client email" },
  { token: "contactPerson", label: "Contact person" },
  { token: "code", label: "Document code" },
  { token: "policyNumber", label: "Policy number" },
  { token: "productName", label: "Product name" },
  { token: "insurerName", label: "Insurer name" },
  { token: "insurerEmail", label: "Insurer email" },
  { token: "consultantName", label: "Consultant name" },
  { token: "amount", label: "Amount" },
  { token: "currency", label: "Currency" },
  { token: "periodFrom", label: "Period from" },
  { token: "periodTo", label: "Period to" },
  { token: "insuredName", label: "Insured name" },
  { token: "companyName", label: "Company name" },
  { token: "companyAddress", label: "Company address" },
  { token: "companyPhone", label: "Company phone" },
  { token: "companyEmail", label: "Company email" },
  { token: "companyWebsite", label: "Company website" },
  { token: "today", label: "Today" },
];

export const GI_DOCUMENT_PASSWORD_PLACEHOLDERS = [
  ...GI_DOCUMENT_EMAIL_PLACEHOLDERS,
  { token: "pdfPassword", label: "PDF password" },
];

const GI_TEMPLATE_PREFIXES = ["DEBIT_NOTE", "QUOTATION", "RENEWAL"];

export function placeholdersForTemplateType(type) {
  const value = String(type || "");
  const isGi = GI_TEMPLATE_PREFIXES.some((prefix) => value.startsWith(prefix));
  const isPassword = value.endsWith("_PASSWORD");
  if (isGi) {
    return isPassword
      ? GI_DOCUMENT_PASSWORD_PLACEHOLDERS
      : GI_DOCUMENT_EMAIL_PLACEHOLDERS;
  }
  return isPassword ? AR_FORM_PASSWORD_PLACEHOLDERS : AR_FORM_EMAIL_PLACEHOLDERS;
}

export function placeholderMarkup(token) {
  return `{{${token}}}`;
}
